module.exports = __webpack_public_path__ + "static/media/taro3.dd74c63f.jpg";